<template>
  <div class="mt-2">
    <small
      class="text-info"
    >{{ $t('Usable variables') }}
    </small>
    <ul class="list-unstyled mt-2 d-flex flex-wrap flex-row flex-md-column justify-content-between text-success">
      <li
        class="cursor-pointer mb-1"
        @click="insetToMessage('[name]')"
      >
        [name] {{ $t('Contact name') }}
      </li>
      <li
        class="cursor-pointer mb-1"
        @click="insetToMessage('[phone]')"
      >
        [phone] {{ $t('Phone') }}
      </li>
      <li
        class="cursor-pointer mb-1"
        @click="insetToMessage('[city]')"
      >
        [city] {{ $t('City') }}
      </li>
      <li
        class="cursor-pointer mb-1"
        @click="insetToMessage('[company]')"
      >
        [company] {{ $t('Company') }}
      </li>
      <li
        class="cursor-pointer mb-1"
        @click="insetToMessage('[gender]')"
      >
        [gender] {{ $t('Gender') }}
      </li>
      <li
        class="cursor-pointer mb-1"
        @click="insetToMessage('[birthday]')"
      >
        [birthday] {{ $t('Birthday') }}
      </li>
    </ul>
    <small
      class="text-danger"
    >{{ $t('Variables alert') }}
    </small>
  </div>
</template>

<script>
import { insertAtCursor } from '../../../common/utils/utils'

export default {
  name: 'CampaignMessageHelper',
  methods: {
    insetToMessage(value) {
      const field = document.getElementById('message-text')
      return insertAtCursor(field, ` ${value} `)
    },
  },
}
</script>

<style scoped>

</style>
